module.exports = __webpack_public_path__ + "img/dnswxt.d5caa3cb.png";